import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const LoaderContainer = styled.div`
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    background: rgba(255, 255, 255, 0.9);
    display: block;
    padding: 0;
    z-index: 1024;
`;

export const Spinner = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${getPurpurSpacing('600')};
    height: ${getPurpurSpacing('600')};

    &::before,
    &::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        animation: grow-and-fade 2s infinite;
        content: '';
        opacity: 0;
        z-index: 1;
    }

    &::before {
        border: 2px solid ${getPurpurColor('purple500')};
        box-shadow:
            0 0 2px ${getPurpurColor('purple500')},
            inset 0 0 1px ${getPurpurColor('purple500')};
    }

    &::after {
        animation: grow-and-fade 2s infinite -0.5s;
        border: 2px solid ${getPurpurColor('functionalWhite')};
        box-shadow:
            0 0 2px ${getPurpurColor('functionalWhite')},
            inset 0 0 1px ${getPurpurColor('functionalWhite')};
        z-index: 2;
    }

    @keyframes grow-and-fade {
        0% {
            transform: scale(0);
            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        100% {
            transform: scale(1);
            opacity: 0;
        }
    }
`;
